import React from "react";
import { SouthRounded } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

import { Account, ExternalAccount } from "fond/types";

import { AccountBox } from "./AccountBox";

type AccountSwitchDisplayProps = {
  currentAccount: Account | ExternalAccount;
  targetAccount: Account | ExternalAccount;
  warningMessage?: string;
};

/**
 * Displays two accounts (current and target) with an arrow between them,
 * used for account switching flows.
 */
export const AccountSwitchDisplay: React.FC<AccountSwitchDisplayProps> = ({
  currentAccount,
  targetAccount,
  warningMessage = "Switching accounts will reload your workspace. Make sure any work in progress is saved first.",
}) => {
  return (
    <>
      <AccountBox account={currentAccount} isCurrent />
      <Box width="100%" sx={{ display: "flex", justifyContent: "center" }}>
        <SouthRounded color="action" fontSize="small" />
      </Box>
      <AccountBox account={targetAccount} isCurrent={false} />
      {warningMessage && <Typography>{warningMessage}</Typography>}
    </>
  );
};
